import React from "react";
import Header from "../components/Header";
import BuiltBy from "../components/BuiltBy";
import { portfolioData } from "../data/portfolio";

const BlogPage = () => {
  const { blogPosts } = portfolioData;

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <Header />

      <main className="pt-32 pb-20 px-6">
        <div className="max-w-6xl mx-auto">
          
          {/* Page Title */}
          <div className="mb-16 text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">Blog</h1>
            <div className="w-20 h-1 bg-[#00b4d8] mx-auto mb-6"></div>
          </div>

          {/* Blog Grid */}
          <div className="grid md:grid-cols-3 gap-6">
            {blogPosts.map((post) => (
              <article
                key={post.id}
                className="bg-[#151515] border border-white/10 rounded-xl overflow-hidden hover:border-[#00b4d8] transition-all duration-300 group"
              >
                {/* Image */}
                <div className="aspect-video bg-[#1a1a1a] overflow-hidden">
                  <img
                    src={post.imageUrl}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>

                {/* Content */}
                <div className="p-6 flex flex-col h-full">
                  {/* Date */}
                  <p className="text-sm text-[#666666] mb-3">
                    {new Date(post.date).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })}
                  </p>

                  {/* Title */}
                  <a
                    href={post.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xl font-semibold mb-3 leading-tight hover:text-[#00b4d8] transition-colors"
                  >
                    {post.title}
                  </a>

                  {/* Excerpt */}
                  <p className="text-[#a0a0a0] leading-relaxed line-clamp-3">
                    {post.excerpt}
                  </p>
                </div>
              </article>
            ))}
          </div>

        </div>
      </main>

      <BuiltBy />
    </div>
  );
};

export default BlogPage;
